document.addEventListener("DOMContentLoaded", function () {
  console.log("DEBUG: WINDOW Coordinate Listener Test - DOM Loaded.");
  // Only run on desktop
  if (window.innerWidth < 750) {
    console.log("DEBUG: Mobile width, skipping.");
    return;
  }

  // --- Listener on the entire window (Capture Phase) ---
  window.addEventListener(
    "click",
    function (event) {
      // Find the card wrapper closest to the actual click target
      const cardWrapper = event.target.closest(
        ".collection .product-card-wrapper, .featured-collection .product-card-wrapper"
      );

      // Only proceed if the click happened inside a relevant product card
      if (cardWrapper) {
        // Log that the listener fired within a card
        // console.log(`%cDEBUG: WINDOW CLICK LISTENER FIRED (Capture Phase) inside Card. Target: ${event.target.tagName}.${event.target.className}`, 'color: magenta;');

        // *** Make sure this selector matches your button ***
        const quickAddButton = cardWrapper.querySelector(
          ".quick-add--desktop button.quick-add__submit"
        );

        const quickAddContainer = cardWrapper.querySelector(
          ".card__inner .quick-add--desktop"
        );

        // Check if the button and container exist in this card
        if (quickAddButton && quickAddContainer) {
          // Check if the button should be considered visible (based on container opacity)
          const quickAddIsVisible =
            window.getComputedStyle(quickAddContainer).opacity === "1";

          if (quickAddIsVisible) {
            // --- USE COORDINATE CHECKING ---
            // Get click coordinates relative to the viewport
            const clickX = event.clientX;
            const clickY = event.clientY;

            // Get button's position and size relative to the viewport
            const buttonRect = quickAddButton.getBoundingClientRect();

            // Check if the click coordinates are within the button's rectangle
            const clickedOnButton =
              clickX >= buttonRect.left &&
              clickX <= buttonRect.right &&
              clickY >= buttonRect.top &&
              clickY <= buttonRect.bottom;
            // --- END COORDINATE CHECKING ---

            if (clickedOnButton) {
              // Click was within button bounds
              console.log(
                `%cDEBUG: Click detected within Button Bounds! Stopping propagation & preventing default.`,
                "color: green; font-weight: bold;"
              );
              // --- Stop other listeners & default navigation ---
              event.stopPropagation();
              event.preventDefault();

              // --- Manually trigger the button's form submission ---
              const form = quickAddButton.closest("form");
              if (form) {
                console.log(`DEBUG: Triggering form submit.`);
                // Use requestSubmit if available (more modern)
                if (typeof form.requestSubmit === "function") {
                  form.requestSubmit(quickAddButton);
                } else {
                  // Fallback for older browsers
                  form.submit();
                }
              } else {
                console.error(`DEBUG: No parent form found for button!`);
                // Add alternative logic here if needed (e.g., for modal triggers)
              }
            } else {
              // Click occurred within card, button visible, but NOT within button bounds
              console.log(
                `%cDEBUG: Click detected OUTSIDE Button Bounds. Allowing default action (navigation).`,
                "color: gray;"
              );
              // Let event continue to allow link navigation
            }
          } else {
            // Button wasn't visible, allow default action
            // console.log(`%cDEBUG: Quick add button not visible. Allowing default action.`, 'color: gray;');
          }
        } else {
          // Button/Container not found in card, allow default action
          // console.log(`%cDEBUG: Button/Container not found in card where click occurred. Allowing default action.`, 'color: gray;');
        }
      } else {
        // Click was outside any relevant product card wrapper
      }
    },
    { capture: true }
  ); // *** CRITICAL: Use capture: true ***

  console.log("DEBUG: WINDOW Coordinate Listener setup finished.");

  // Optional: Keep setup logs for card elements if helpful
  /*
  const productCards = document.querySelectorAll('.collection .product-card-wrapper, .featured-collection .product-card-wrapper');
  productCards.forEach((card, index) => {
      const fullLink = card.querySelector('a.full-unstyled-link');
      const quickAddButton = card.querySelector('button.quick-add__submit');
      // console.log(`DEBUG: Card ${index}: Link found=${!!fullLink}, Button found=${!!quickAddButton}`);
       if (fullLink) {
           const linkPointerEvents = window.getComputedStyle(fullLink).pointerEvents;
           // console.log(`DEBUG: Card ${index}: Initial computed pointer-events for LINK = ${linkPointerEvents}`);
       }
  });
  */
}); // End of DOMContentLoaded
